module.exports = __webpack_public_path__ + "img/video_qrcode.6c2c598.jpg";